<template>
  <div class="container">
    <div class="row g">
      <div v-if="admin" class="col-12">
        <div class="box mt-2">
          <div class="heading">
            <h3>{{ admin.name }}</h3>
            <button class="btn btn-primary" @click="openEditOffcanvas">編集</button>
          </div>
          <hr/>
          <div class="row mb-3">
            <div class="col-12 col-md-3 mb-2">
              <label class="text-muted mb-2">メールアドレス</label>
              <div class="fs-5">{{ admin.email }}</div>
            </div>
            <div class="col-12 col-md-3 mb-2">
              <label class="text-muted mb-2">ステータス</label>
              <div class="fs-5">{{ admin.status.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <AdminEditOffcanvas :admin="admin" @update="fetch"/>
</template>

<script setup>
import {onMounted, ref} from 'vue';
import {useRoute} from 'vue-router';
import {getAdmin} from '../../../api/admin/AdminApi';
import useOffcanvas from '../../../composables/useOffcanvas';
import AdminEditOffcanvas from './AdminEditOffcanvas.vue';

const {openOffcanvas: openEditOffcanvas} = useOffcanvas('adminEditOffcanvas');

const route = useRoute();

const admin = ref();

onMounted(async () => {
  await fetch();
});

/**
 * 管理者の詳細を取得
 * @returns {Promise<void>}
 */
const fetch = async () => {
  admin.value = await getAdmin(route.params.id);
};
</script>
